import React from "react";
import axios from "axios";
import _ from "lodash";
import config from "../../app/config";
import moment from "moment";

export class AdminAPI {
    static DefaultApiName = "apiUrl";

    static getTableData(tableName, signal, filter, page, pagesize, sort, api= AdminAPI.DefaultApiName) {
        let postdata = {};
        if(filter && _.isObject(filter)) {
            postdata = filter;
        }
        let uri = `/admindata/filter?collectionName=${tableName}`;

        if(page) {
            uri = `${uri}&$page=${page}`;
        }
        if(pagesize) {
            uri = `${uri}&$pageSize=${pagesize}`;
        }
        if(sort) {
            uri = encodeURI(`${uri}&$sort={${sort}}`);
        }
        return new Promise(async function (resolve, reject) {
            if(config.hasOwnProperty(api)) {
                let url = `${config[api]}${uri}`;
                axios.post(url, postdata, {signal: signal}).then((response) => {
                    //console.log("tableName: " + tableName, response.data);
                    resolve(response.data);
                }).catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
            } else {
                reject(`incorrect api name [${api}], missing in config`);
            }

            // TODO: error handling ???
        });
    }

    static deleteTableRecord(tableName, itemId, api= AdminAPI.DefaultApiName){
        return new Promise(async function(resolve, reject){
            let url = `${config[api]}/admindata/delete?collectionName=${tableName}`;
            axios.post(url, { _id : itemId}).then(() => {
                resolve(true);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                } else {
                    console.log(error); ///aborted??
                    resolve(false);
                }
            });
        })
    }
    static mergeRecords(endpoint,idFrom,idTo) {
        return new Promise(async function(resolve, reject){
            let url = `${config.apiUrl}/${endpoint}`;
            let postData = {
                from : idFrom,
                to : idTo
            }
            axios.post(url, postData).then((resSave) => {
                if(resSave && resSave.data){
                    resolve(resSave.data);
                }
                resolve(false);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                } else {
                    console.log(error); ///aborted??
                    resolve(false);
                }
            });
        })
    }
    static saveTableRecord(tableName, record, api= AdminAPI.DefaultApiName){
        return new Promise(async function(resolve, reject){
            let url = `${config[api]}/admindata/save?collectionName=${tableName}`;
            axios.post(url, record).then((resSave) => {
                if(resSave && resSave.data){
                    resolve(resSave.data);
                }
                resolve(false);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                } else {
                    console.log(error); ///aborted??
                    resolve(false);
                }
            });
        })
    }
    static resendFhir(ids) {
        let uri = `/theatresessions/resendFhir`;
        return new Promise(async function(resolve, reject) {
            axios.post(config.apiUrl + uri, ids).then((resSave) => {
                if (resSave) {
                    resolve(resSave);
                }
                resolve(false);
            }).catch(error => {
                if (error?.message !== "canceled") {
                    reject(error);
                } else {
                    console.log(error); ///aborted??
                    resolve(false);
                }
            });
        })
    }
    static getFHIRLog(filter,pageNumber,pageSize, sort) {
        let uri = `/theatresessions/fhirLog`;
        let params = {
            $filter: filter,
            $page : pageNumber,
            $pageSize: pageSize,
            $sort:sort
        }
        const cfg = {
            params: params
        };
        return new Promise((resolve, reject) => {
            axios.get(config.apiUrl + uri, cfg).then(
                (response) => {
                    if (response) {
                        resolve(response);
                    } else {
                        resolve([]);
                    }
                },
                (failed) => {
                    if (failed.status == 401) {
                        // this._rootShareService.addIndicatorNotification(
                        //     new NotificationMessage(MessageType.error,
                        //         this._translate.instant("Response_Error_401"),
                        //         this._rootShareService.environment.defaultNotificationDuration));
                        // this._router.navigate([''])
                    }
                    reject(failed.status);
                }
            )
        });
    }
    static getHl7SendLog(messageType, dateFrom, dateTo, patientId, errorsPrepare,
                  errorsSend,pageNumber,pageSize, sort,message,messageID) {
        let uri = `/hl7admin/hl7sendLog`;

        let params = {
            dateFrom: moment.isMoment(dateFrom) ? dateFrom.format("YYYY-MM-DD HH:mm") : dateFrom,
            dateTo: moment.isMoment(dateTo) ? dateTo.format("YYYY-MM-DD HH:mm") : dateTo,
            pageNumber : pageNumber,
            pageSize: pageSize,
            sort:sort
        }
        if(messageType)
            params.messageType = messageType;
        if(patientId)
            params.patientId = patientId;

        if(errorsPrepare)
            params.prepareError = errorsPrepare;

        if(errorsSend)
            params.sendError = errorsSend;
        if(message) {
            params.message = message;
        }
        if(messageID) {
            params.messageID = messageID;
        }
        const cfg = {
            params: params
        };

        return new Promise((resolve, reject) => {
            axios.get(config.apiUrl + uri, cfg).then(
                (response) => {
                    if (response) {
                        resolve(response);
                    } else {
                        resolve({__data:[],__pageCount:0,__pageNumber:0,__pageSize:pageSize,__size:0});
                    }
                },
                (failed) => {
                    if (failed.status == 401) {
                        // this._rootShareService.addIndicatorNotification(
                        //     new NotificationMessage(MessageType.error,
                        //         this._translate.instant("Response_Error_401"),
                        //         this._rootShareService.environment.defaultNotificationDuration));
                        // this._router.navigate([''])
                    }
                    reject(failed.status);
                }
            )
        });
    }

    static getNhsUpsertStat(statType) {
        return new Promise((resolve, reject) => {
            axios.get(config.apiUrl + `/admindata/lastUpsert/${statType}`).then(
                (response) => {
                    resolve(response.status == 200 ? response.data : undefined);
                },
                (failed) => {
                    if (failed.status == 401) {
                    } else {
                        reject(failed.status);
                    }
                },
            );
        });
    }
    static syncSurgeries(date) {
        const headers = {
            'Content-Type': 'application/json'
        }
        return new Promise((resolve, reject) => {
            axios.post(`${config.apiUrl}/admindata/syncSurgeries`,date.valueOf(),{headers:headers}).then(
                (response) => {
                    resolve({status: "ok", data: response.data});
                },
                (failed) => {
                    if(failed.status == 401) {
                        reject(failed.message)
                    }else {
                        reject(failed.message);
                    }
                }
            )
        });
    }
    static sendData(selectedFile, selectedFileName, upsertTarget, api= AdminAPI.DefaultApiName) {
        if(config.hasOwnProperty(api)) {
            let uri = `/admindata/${upsertTarget}`;
            let url = `${config[api]}${uri}`;
            return new Promise(async function (resolve) {
                // let formData = new FormData();
                // formData.append('file', selectedFile, selectedFileName);
                const headers = {
                    'Content-Type': 'text/csv',
                    'Force-Accept': 'application/json'
                }
                axios.post(url, selectedFile,
                    {withCredentials: window.envConfig.hasOwnProperty('withCredentials') ? window.envConfig.withCredentials : true,
                        headers:headers}).then(
                    (response) => {
                        //console.log(data);
                        if(response.status == 200) {
                            resolve({status: "ok", data: response.data});
                        }else {
                            resolve({status: "error", data: response.statusText});
                        }
                    },
                    err => {
                        resolve({status: "error", data: err.message});
                        console.log(err);
                    }
                );
            });
        }
    }

    static getFieldAsTableFromMasterTable(tableName, field, signal, api= AdminAPI.DefaultApiName) {
        let uri = `/admindata/filter?collectionName=${tableName}`;
            uri = `${uri}&$page=0`;
            uri = `${uri}&$pageSize=1`;
        return new Promise(async function (resolve, reject) {
            if(config.hasOwnProperty(api)) {
                let url = `${config[api]}${uri}`;
                axios.post(url, {}, {signal: signal}).then((response) => {
                    if(response.data.length == 0){
                        resolve({id: null, data: []});
                    } else {
                        if(response.data[0].hasOwnProperty(field)){
                            resolve({id: response.data[0]._id, data: response.data[0][field]});
                        } else {
                            resolve({id: response.data[0]._id, data: []});
                        }
                    }
                }).catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
            } else {
                reject(`incorrect api name [${api}], missing in config`);
            }

            // TODO: error handling ???
        });
    }

    static updateMasterRecordFieldData(tableName, field, data, api= AdminAPI.DefaultApiName) {
        return new Promise((resolve)=>{
            this.getTableData(tableName, null, null, 0, 1, null, api).then(itemsArray => {
                if(itemsArray.length == 1){
                    itemsArray[0][field] = data;
                    resolve(this.saveTableRecord(tableName, itemsArray[0], api));
                } else {
                    console.log("Wrong item collection length", tableName, itemsArray);
                }
            }, error => {
                console.log(error);
                resolve(false)
            })
        })
    }
}